import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05),
    0px 6px 12px rgba(61, 69, 67, 0.05);

  width: 100%;
  padding: 15px 0;
  margin: 0 5px;

  strong,
  span {
    text-align: center;
    font-size: 16px;
    color: ${props => props.theme.colors.text};
    margin-top: 10px;
    width: 350px;
  }

  form {
    margin: 25px 0;
  }

  p {
    font-size: 14px;
    text-align: center;
    width: 90%;
    line-height: 22px;

    > strong {
      font-size: 14px;
    }
  }
`

export const AlertContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  padding: 12px 24px;
  background: ${props => props.theme.colors};
  color: ${props => props.theme.colors.error};
  border-radius: 4px;
  width: 340px;
  max-width: 90vw;
  font-weight: bold;
  margin-bottom: 12px;
  box-sizing: border-box;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: fit-content;
    margin-bottom: 5px;
  }

  svg {
    font-size: 20px;
    flex-shrink: 0;
  }

  button {
    border: none;
    background-color: transparent;
    font-size: 12px;
    color: #333;
    &:hover {
      text-decoration: underline;
    }
  }
`

export const Timer = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.primary};
  margin: 12px 0;

  @media screen and (min-width: 766px) {
    font-size: 14px;
  }
`

export const LinkBack = styled(Link)`
  text-decoration: none;
  border: none;
  background-color: unset;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6px;
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.text};
    transition: all 0.2s ease;
  }
  &:focus {
    text-decoration: underline;
  }

  @media screen and (min-width: 766px) {
    font-size: 14px;
    padding: 8px;
  }
`
